import { Box, Grid } from '@mui/material';
import { useParams } from 'react-router';
import { ArticlesSection } from '../components/Article/ArticlesSection';
import { useTranslation } from 'react-i18next';
import ArticlesSectionSkeleton from '../components/Article/ArticlesSectionSkeleton';
import ErrorView from '../components/ErrorViews/ErrorView';
import useDocumentTitle from '../hooks/useDocumentTitle';
import PageHeader from '../components/Page/PageHeader';
import OpenGraphGeneral from '../components/MetaData/OpenGraphGeneral';
import { articleCardLocation } from '../utilities/gtm';
import { apiStates } from '../types/types';
import { UseArticlesResult, useArticles } from '../hooks/useArticles';

export default function AuthorPage() {
  const { t } = useTranslation();
  const { author } = useParams();
  useDocumentTitle(t('author.title', { author }));

  const {
    hasNextPage,
    fetchNextPage,
    articles,
    totalArticleCount,
    apiError,
    state: apiState,
  }: UseArticlesResult = useArticles({
    limit: 10,
    contentType: [],
    includeUpcoming: true,
    author,
  });

  // If category is not matching any known categories, show "Content not found" view
  if (apiState === apiStates.HAS_ERROR) {
    return (
      <Box
        sx={{
          paddingX: { xs: 2, sm: 0 },
        }}
      >
        <ErrorView apiError={apiError || null} />
      </Box>
    );
  }

  return (
    <Box>
      <PageHeader title={`${t('author.contentFrom')}  ${author ?? ''}`} />
      <Grid container component='section'>
        <Grid
          size={{
            xs: 12,
            lg: 8,
          }}
        >
          {apiState === apiStates.FETCHING && (
            <ArticlesSectionSkeleton hideCoverImages />
          )}
          {apiState === apiStates.READY && (
            <ArticlesSection
              articles={articles}
              headingLevel='h2'
              hasNextPage={hasNextPage}
              fetchNextPage={fetchNextPage}
              totalArticleCount={totalArticleCount}
              location={articleCardLocation.MAIN_CONTENT}
              showArticleAmount
              hideCoverImages
            />
          )}
        </Grid>
      </Grid>
      <OpenGraphGeneral />
    </Box>
  );
}
